import React from 'react';
import { useParams, Outlet, useLocation, Navigate } from 'react-router-dom';
import { isSupportedLanguage, getBestSupportedLanguageForCountry } from '../utils/countryLanguageEngine';

const MarketLayout = () => {
    const { country, language } = useParams();
    const location = useLocation();

    const normalizedCountry = (country || '').toLowerCase().trim();
    const normalizedLang = (language || '').toLowerCase().trim();

    // Accept any valid 2-letter ISO country code (e.g. sa, us, my, hk, ng, fr, de, etc.)
    const isIsoCountry = /^[a-z]{2}$/.test(normalizedCountry);
    // Validate that the language is one of the 14 officially supported sovereign languages
    const isValidLanguage = isSupportedLanguage(normalizedLang);

    // Auto-Correction: If country or language is invalid, seamlessly auto-correct immediately (0ms)
    // Customers will NEVER see an error screen or warning triangle.
    if (!isIsoCountry || !isValidLanguage) {
        let targetCountry = isIsoCountry ? normalizedCountry : 'sa';
        let targetLang = isValidLanguage ? normalizedLang : getBestSupportedLanguageForCountry(targetCountry);

        // Preserve remaining subpath, e.g. /my/ms/cart -> /my/en/cart
        const pathParts = location.pathname.split('/').filter(Boolean);
        const subpath = pathParts.slice(2).join('/');
        const trailingSlash = location.pathname.endsWith('/') ? '/' : '';
        const targetUrl = `/${targetCountry}/${targetLang}/${subpath ? subpath + trailingSlash : ''}${location.search || ''}${location.hash || ''}`;

        return <Navigate to={targetUrl} replace />;
    }

    // Valid Market: Render child routes seamlessly
    return <Outlet />;
};

export default MarketLayout;
